import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const OpenCreateNewSidenav = createAction('[RedeemRules: CreateNew]: Open Sidenav');

export const OpenEditSidenav = createAction(
  '[RedeemRules: CreateNew]: Open Edit Sidenav',
  props<{ rule: any; ruleIndex: number }>(),
);

export const CloseCreateNewSidenav = createAction('[RedeemRules: CreateNew]: Close Sidenav');

export const GetRedemptionTypesSuccess = createAction(
  '[RedeemRules: CreateNew]: Get Redemption Types Success',
  props<{ res: string[] }>(),
);

export const GetRedemptionTypesFailed = createAction(
  '[RedeemRules: CreateNew]: Get Redemption Types Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetMemberCategoriesSuccess = createAction(
  '[RedeemRules: CreateNew]: Get Member Categories Success',
  props<{ res: any[] }>(),
);

export const GetMemberCategoriesFailed = createAction(
  '[RedeemRules: CreateNew]: Get Member Categories Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetMemberStatusesSuccess = createAction(
  '[RedeemRules: CreateNew]: Get Member Statuses Success',
  props<{ res: any[] }>(),
);

export const GetMemberStatusesFailed = createAction(
  '[RedeemRules: CreateNew]: Get Member Statuses Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetMemberTagsSuccess = createAction(
  '[RedeemRules: CreateNew]: Get Member Tags Success',
  props<{ res: any[] }>(),
);

export const GetMemberTagsFailed = createAction(
  '[RedeemRules: CreateNew]: Get Member Tags Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCurrenciesSuccess = createAction(
  '[RedeemRules: CreateNew]: Get Currencies Success',
  props<{ res: any[] }>(),
);

export const GetCurrenciesFailed = createAction(
  '[RedeemRules: CreateNew]: Get Currencies Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCouponSetsSuccess = createAction(
  '[RedeemRules: CreateNew]: Get Coupon Sets Success',
  props<{ res: any[] }>(),
);

export const GetCouponSetsFailed = createAction(
  '[RedeemRules: CreateNew]: Get Coupon Sets Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetBookCouponTemplatesSuccess = createAction(
  '[RedeemRules: CreateNew]: Get Book Coupon Templates Success',
  props<{ res: any[] }>(),
);

export const GetBookCouponTemplatesFailed = createAction(
  '[RedeemRules: CreateNew]: Get Book Coupon Templates Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const SchemaChanged = createAction(
  '[RedeemRules: CreateNew]: Schema Changed',
  props<{ schemaCode: string; schemaId: number | null }>(),
);

export const RedemptionTypeChanged = createAction(
  '[RedeemRules: CreateNew]: Redemption Type Changed',
  props<{ redemptionType: string }>(),
);

export const MemberCategoryChanged = createAction(
  '[RedeemRules: CreateNew]: Member Category Changed',
  props<{ memberCategoryCode: string }>(),
);

export const MemberStatusChanged = createAction(
  '[RedeemRules: CreateNew]: Member Status Changed',
  props<{ memberStatusCode: string }>(),
);

export const MemberTagChanged = createAction(
  '[RedeemRules: CreateNew]: Member Tag Changed',
  props<{ memberTagCode: string }>(),
);

export const PointsChanged = createAction(
  '[RedeemRules: CreateNew]: Points Changed',
  props<{ points: number | null }>(),
);

export const AmountChanged = createAction(
  '[RedeemRules: CreateNew]: Amount Changed',
  props<{ amount: number | null }>(),
);

export const CurrencyChanged = createAction(
  '[RedeemRules: CreateNew]: Currency Changed',
  props<{ currency: string }>(),
);

export const DiscountChanged = createAction(
  '[RedeemRules: CreateNew]: Discount Changed',
  props<{ discount: number | null }>(),
);

export const CouponSetChanged = createAction(
  '[RedeemRules: CreateNew]: Coupon Set Changed',
  props<{ couponSetCode: string }>(),
);

export const BookCouponTemplateChanged = createAction(
  '[RedeemRules: CreateNew]: Book Coupon Template Changed',
  props<{ bookCouponTemplateCode: string }>(),
);

export const MessageChanged = createAction(
  '[RedeemRules: CreateNew]: Message Changed',
  props<{ message: string }>(),
);

export const SubmitCreateNew = createAction('[RedeemRules: CreateNew]: Submit');

export const SubmitCreateNewValid = createAction('[RedeemRules: CreateNew]: Submit Valid');

export const SubmitUpdateValid = createAction('[RedeemRules: CreateNew]: Submit Update Valid');

export const SubmitCreateNewSuccess = createAction('[RedeemRules: CreateNew]: Submit Success');

export const SubmitCreateNewFailed = createAction(
  '[RedeemRules: CreateNew]: Submit Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const LoadCreateNewData = createAction('[RedeemRules: CreateNew]: Load Data');

export const DeleteRedemptionRule = createAction(
  '[RedeemRules: CreateNew]: Delete Redemption Rule',
  props<{ ruleIndex: number }>(),
);

export const DeleteRedemptionRuleSuccess = createAction(
  '[RedeemRules: CreateNew]: Delete Redemption Rule Success',
);

export const DeleteRedemptionRuleFailed = createAction(
  '[RedeemRules: CreateNew]: Delete Redemption Rule Failed',
  props<{ error: HttpErrorResponse }>(),
);
